import { render, staticRenderFns } from "./AddCustomerGroup.vue?vue&type=template&id=1d016f72&scoped=true&"
import script from "./AddCustomerGroup.vue?vue&type=script&lang=js&"
export * from "./AddCustomerGroup.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomerGroup.vue?vue&type=style&index=0&id=1d016f72&lang=scss&scoped=true&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d016f72",
  null
  
)

export default component.exports